<template>
	<div class="d-flex flex-column justify-center mx-auto">
		<div class="my-5 mx-auto">
			<h1>{{$t('attributes.helpVideo')}}</h1>
		</div>
		<div class="d-flex py-5 mx-auto">
			<h2> סרטון מבוא</h2>
		</div>
		<div class="d-flex py-5 mx-auto">
			<iframe
          width="800" height="640"
          src="https://www.youtube.com/embed/4ptMoBRuf6I"
          frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
		</div>
		<div class="d-flex py-5 mx-auto">
			<h2>סרטון הזמנות</h2>
		</div>
		<div class="d-flex py-5 mx-auto">
			<iframe width="800" height="640" src="https://www.youtube.com/embed/whvI_Z-KDX0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</div>
		<div class="d-flex py-5 mx-auto">
			<h2>ניהול משתמשים</h2>
		</div>
		<div class="d-flex py-5 mx-auto">
			<iframe width="800" height="640" src="https://www.youtube.com/embed/X_kAxdRBF6M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</div>

		<div class="d-flex py-5 mx-auto">
			<h2>הפקת דוחות</h2>
		</div>
		<div class="d-flex py-5 mx-auto">
			<iframe width="800" height="640" src="https://www.youtube.com/embed/8vH3NS9meNY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

		</div>
	</div>
</template>

<script>

	export default {
		name:"video-view"
	};
</script>

<style>

</style>